import { Collapse, Flex } from "antd";
import { t } from "i18next";
import { useState } from "react";
import style from "./CollapseArrayView.module.scss";

interface Props {
  items: Array<string>;
  elementKey: string;
}

const CollapseArrayView = ({ items, elementKey }: Props) => {
  const [expandedValues, setExpandedValues] = useState<{
    [key: string]: boolean;
  }>({ [elementKey]: false });

  const remainingItemsLength = items?.slice(3)?.length;

  const remainingItemsNumber =
    remainingItemsLength > 1 ? `(+${remainingItemsLength})` : "";

  const label = !expandedValues?.[elementKey]
    ? t("COMMON.PRIKAZI_VISE")
    : t("COMMON.PRIKAZI_MANJE");

  const toggleExpand = (values?: string | string[]) => {
    const isExpanded = Array.isArray(values) && values?.includes(elementKey);

    setExpandedValues(() => ({
      [elementKey]: isExpanded,
    }));
  };

  const collapseItems = [
    {
      key: elementKey,
      label: <strong>{`${remainingItemsNumber} ${label}`}</strong>,
      children: (
        <Flex vertical>
          {items?.slice(3)?.map((item, index) => (
            <span key={index}>{item}</span>
          ))}
        </Flex>
      ),
    },
  ];

  return (
    <Collapse
      className={style.collapse}
      items={collapseItems}
      expandIconPosition="end"
      onChange={toggleExpand}
      ghost
    />
  );
};

export default CollapseArrayView;
